import React from 'react'
import { PulseLoader } from 'react-spinners'

export default (props) => {
  return (
    <PulseLoader
      sizeUnit={'px'}
      size={30}
      color={'#123abc'}
      loading={props.loading}
    />
  )
}
